import {ComponentLoader} from "../common";
import {IComponentLoaderProps} from "../common/component-loader";


export type IPharmacyMedicationProps = Omit<IComponentLoaderProps,'emptyResultMessage'>;

export const PharmacyMedicationsLoader = (props:IPharmacyMedicationProps)=>{
    let newProps={
      ...props,
        emptyResultMessage:'No medications found for the resident'
    };
    return <ComponentLoader {...newProps}>
        {props.children}
    </ComponentLoader>
}